import { auth } from "@Firebase/firebase";

function extractGCSPath(publicUrl: string): string {
  const prefix =
    "https://storage.googleapis.com/dealership_platform_blog_videos/";
  if (!publicUrl.startsWith(prefix)) {
    throw new Error("Unexpected URL format");
  }
  return publicUrl.substring(prefix.length);
}

export const fetchVideoUrl = async (url: string) => {
  const token = await auth.currentUser?.getIdToken();

  if (!token) {
    throw new Error("User must be authenticated to get files");
  }

  const response = await fetch(
    `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/get-secure-download-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ filePath: extractGCSPath(url) }),
    }
  );
  const data = await response.json();
  return data.signedUrl;
};
